import * as http from '@/util/http'

export const ProgressFlags = {
  PROFILE_INIT: 1,
  ADDR_FILLED: 1 << 1,
  EDU_HISTORY_FILLED: 1 << 2,
  JOB_PREFS_SELECTED: 1 << 3,
  INTERESTS_SELECTED: 1 << 4,
} as const

export type ProgressFlag = (typeof ProgressFlags)[keyof typeof ProgressFlags]

export type ProgressFlags = {
  flags: number
}

export async function fetchProgressFlags() {
  const { data } = await http.get<ProgressFlags>('/api/v1/user/profile/progress')
  return data.flags
}

export async function saveProgress(flags: ProgressFlag) {
  http.put('/api/v1/user/profile/progress', {
    payload: { flags },
  })
}
